module.exports = __webpack_public_path__ + "fonts/Lato-HairlineItalic.d3db3ad8.woff2";